(() => {
  if (window.__merisCartDrawerReady) return;
  window.__merisCartDrawerReady = true;

  const root = () => window.Shopify?.routes?.root || '/';

  async function refreshDrawer() {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    await new Promise(resolve => {
      drawer.addEventListener('cart-drawer:refreshed', resolve, { once: true });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
    drawer.show?.();
  }

  document.addEventListener('change', async event => {
    const upsellVariant = event.target.closest('[data-meris-cart-upsell-variant]');
    if (upsellVariant) {
      const price = upsellVariant.selectedOptions[0]?.dataset.price;
      const target = upsellVariant.closest('.meris-cart-upsell')?.querySelector('[data-meris-cart-upsell-price]');
      if (target && price) target.textContent = price;
      return;
    }

    const toggle = event.target.closest('[data-meris-gift-toggle]');
    if (!toggle) return;
    toggle.disabled = true;

    try {
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: { 'Make this a gift': toggle.checked ? 'Yes' : '' }
        })
      });
      if (!response.ok) throw new Error('Unable to update gift preference');
    } catch (error) {
      toggle.checked = !toggle.checked;
      console.error('[Meris cart gift]', error);
    } finally {
      toggle.disabled = false;
    }
  });

  document.addEventListener('click', async event => {
    const applyDiscount = event.target.closest('[data-meris-apply-discount]');
    if (applyDiscount) {
      const field = applyDiscount.closest('cart-discount-field');
      const visibleInput = field?.querySelector('input:not([type="hidden"])');
      if (visibleInput?.value.trim()) visibleInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const button = event.target.closest('[data-meris-subscribe-line]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${root()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: button.dataset.lineKey,
          quantity: Number(button.dataset.quantity || 1),
          selling_plan: Number(button.dataset.sellingPlan)
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to switch to subscription');
      await refreshDrawer();
    } catch (error) {
      console.error('[Meris cart subscription]', error);
      button.removeAttribute('aria-busy');
    }
  });
})();
